import { ReactComponent as POI } from '../../../assets/images/POI.svg';
import { ReactComponent as Phone } from '../../../assets/images/phone.svg';
import { ReactComponent as Mail } from '../../../assets/images/mail.svg';
import { ContactResponse } from '../types';

interface BranchItemProps {
    branchItem: ContactResponse;
}

const BranchItem = ({ branchItem }: BranchItemProps) => {
    return (
        <div style={{ background: 'white', borderRadius: 15, padding: '20px 35px' }}>
            <div className="font-size-24 font-bold text-overflow-custom">{branchItem.title || ""}</div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                <POI style={{ height: 20 }} /><span style={{ paddingLeft: 16, fontSize: 16 }} className="text-overflow-custom">{branchItem.address || ""}</span>
            </div>
            <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                <Phone style={{ height: 20, color: 'black' }} />
                <span style={{ paddingLeft: 16, fontSize: 16 }} className="text-overflow-custom">
                    {branchItem.mobile || ""}
                </span>
            </div>
            <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                <Mail style={{ height: 20, color: 'black' }} />
                <a href={`mailto:${branchItem.email}`} style={{ paddingLeft: 16, fontSize: 16 }} className="text-overflow-custom">
                    {branchItem.email || ""}
                </a>
            </div>
        </div>
    )
}

export default BranchItem;